module.exports = __webpack_public_path__ + "static/media/thrive-logo.47bc9a68.svg";